"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TabsCollection_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/TabsCollection.vue"));
const ModalBulkActions_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/ModalBulkActions.vue"));
const AccessData_1 = __importDefault(require("@becrop/components/Profile/Access/class/models/AccessData"));
const lucide_vue_next_1 = require("lucide-vue-next");
let PreTable = class PreTable extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isBulkActionsModal = false;
        this.toSearch = '';
        this.cropsFilters = [];
        this.isPanelFilters = false;
        this.filterAccess = '';
    }
    clearCropsFilters() {
        this.cropsFilters = [];
        this.filterAccess = '';
        this.toSearch = '';
        this.$emit('filterAccess', this.filterAccess);
        this.$emit('cropsIdsFilters', this.cropsFilters);
        this.$emit('textSearch', this.toSearch);
    }
    openFilterCropsPanel() {
        this.filterAccess = '';
        this.isPanelFilters = true;
    }
    dismissFilterCropsPanel() {
        this.isPanelFilters = false;
    }
    recall() {
        this.$emit('recall');
    }
    emitfilterAccess() {
        this.cropsFilters = [];
        this.toSearch = '';
        this.$emit('filterAccess', this.filterAccess);
    }
    onchangesearch(textSearch) {
        this.toSearch = textSearch;
        this.cropsFilters = [];
        this.filterAccess = '';
        this.$emit('textSearch', textSearch);
    }
    newDimension(newDimension) {
        this.cropsFilters = [];
        this.toSearch = '';
        this.filterAccess = '';
        this.$emit('newDimension', newDimension);
        this.resetSearchBox();
    }
    openBulkActionsModal() {
        this.isBulkActionsModal = true;
    }
    dismissBulkActionsModal() {
        this.$emit('resetItemsCheck');
        this.isBulkActionsModal = false;
    }
    resetSearchBox() {
        this.toSearch = '';
        this.$emit('textSearch', '');
    }
    includeNewFilter(newFilter) {
        if (this.cropsFilters.includes(newFilter)) {
            this.cropsFilters = this.cropsFilters.filter((filter) => filter !== newFilter);
        }
        else {
            this.cropsFilters.push(newFilter);
        }
        this.$emit('cropsIdsFilters', this.cropsFilters);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], PreTable.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new AccessData_1.default() })
], PreTable.prototype, "dataSet", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], PreTable.prototype, "samplesIds", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], PreTable.prototype, "projectsIds", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('filterAccess')
], PreTable.prototype, "emitfilterAccess", null);
PreTable = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            Search: bmk_ui_framework_1.Search,
            TabsCollection: TabsCollection_vue_1.default,
            ModalBulkActions: ModalBulkActions_vue_1.default,
            Filter: lucide_vue_next_1.Filter,
            List: bmk_ui_framework_1.List,
            ListItem: bmk_ui_framework_1.ListItem,
            CheckBox: bmk_ui_framework_1.CheckBox,
            X: lucide_vue_next_1.X,
            Tag: bmk_ui_framework_1.Tag,
            AlertTriangle: lucide_vue_next_1.AlertTriangle,
            FileKey: lucide_vue_next_1.FileKey,
            FileLock: lucide_vue_next_1.FileLock,
        },
    })
], PreTable);
exports.default = PreTable;
